
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    // src/pages/_app.tsx
import '@styles/preflight.css';
import '@styles/global.scss';
import '@styles/tailwind.css';
import '@egjs/flicking/dist/flicking.css';
import 'react-image-hotspot/lib/index.css';
import React from 'react';
import dayjs from 'dayjs';
import Flex from '@react-css/flex';
import Router from 'next/router';
import NProgress from 'nprogress';
import { AppProps } from 'next/app';
import { ConfigProvider, Spin, theme } from 'antd';
import { ApolloProvider, ApolloClient, InMemoryCache } from '@apollo/client';
import { useRouter } from 'next/router';
import { LoadingOutlined } from '@ant-design/icons';
import { IntlProvider } from 'react-intl';
import { RecoilRoot } from 'recoil';
import { ErrorBoundary } from '@components/error';
import { apolloAdminClientSignal, apolloUserClientSignal, apolloClientSignal, } from '@/globals';
import { apolloClientFactory as adminApolloClientFactory } from '@graphql/admin/apollo/apolloClientFactory';
import { apolloClientFactory as userApolloClientFactory } from '@graphql/user/apollo/apolloClientFactory';
import i18n from '../../i18n.json';
const App: React.FC<AppProps> = ({ Component, pageProps }) => {
    const router = useRouter();
    const [apolloClient, setApolloClient] = React.useState<any>(null);
    const locale = React.useMemo(() => router.locale ?? i18n.defaultLocale ?? 'en', [router.locale]);
    const normalizedLocale = locale.toLowerCase().split('-')[0];
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin/>;
    React.useEffect(() => {
        const initApollo = async () => {
            const useAdminClient = router.pathname.split('/').filter(Boolean)?.[0]?.toLowerCase() ===
                'admin';
            const [adminClient, userClient] = await Promise.all([
                adminApolloClientFactory(locale),
                userApolloClientFactory(locale),
            ]);
            apolloAdminClientSignal.update(adminClient);
            apolloUserClientSignal.update(userClient);
            const selectedClient = useAdminClient ? adminClient : userClient;
            setApolloClient(selectedClient);
            apolloClientSignal.update(selectedClient);
        };
        initApollo();
    }, [locale, router.pathname]);
    React.useEffect(() => {
        dayjs.locale(locale);
    }, [locale]);
    React.useEffect(() => {
        const handleStart = () => NProgress.start();
        const handleDone = () => NProgress.done();
        Router.events.on('routeChangeStart', handleStart);
        Router.events.on('routeChangeComplete', handleDone);
        Router.events.on('routeChangeError', handleDone);
        return () => {
            Router.events.off('routeChangeStart', handleStart);
            Router.events.off('routeChangeComplete', handleDone);
            Router.events.off('routeChangeError', handleDone);
        };
    }, []);
    return (<ErrorBoundary>
      <ConfigProvider theme={{
            token: { colorPrimary: '#011951', colorLink: '#011951' },
            components: {
                Menu: { colorItemBgSelected: '#d6dae4' },
                Calendar: { controlItemBgActive: '#d6dae4' },
                Layout: { colorBgHeader: '#ffffff' },
            },
            algorithm: [theme.defaultAlgorithm],
        }}>
        <RecoilRoot>
          <IntlProvider locale={locale} defaultLocale={i18n.defaultLocale} messages={{}}>
            {apolloClient ? (<ApolloProvider client={apolloClient}>
                <Component {...pageProps} key={router.asPath}/>
              </ApolloProvider>) : (<Flex justifyCenter alignItemsCenter style={{ height: '100%', margin: 'auto' }}>
                <Spin indicator={antIcon}/>
              </Flex>
        // <></>
        )}
          </IntlProvider>
        </RecoilRoot>
      </ConfigProvider>
    </ErrorBoundary>);
};
const __Next_Translate__Page__1a11cf05f7e__ = App;

    export default __appWithI18n(__Next_Translate__Page__1a11cf05f7e__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  